<template>
    <v-combobox
        v-if="($attrs.items && $attrs.items != null) || $attrs.disabled"
        v-focus="focus ? focus : false"
        ref="dropdownSelect"
        v-model="selected"
        v-bind="$attrs"
        v-on="$listeners"
        :required="$attrs.rules && $attrs.rules.length > 0"
        :menu-props="menuPropsCombined"
        browser-autocomplete="no"
    >
        <template v-for="(_, slot) of $slots" :slot=[slot]>
            <slot :name="slot"/>
        </template>
        <template v-for="(_, slot) of $scopedSlots" :slot=[slot] slot-scope="data">
            <slot :name="slot" v-bind="data" />
        </template>
    </v-combobox>
    <v-text-field
        v-else
        loading
        readonly
        :label="$attrs.label"
        :value="$attrs.initial ? $attrs.initial : ''"
        :single-line="$attrs['single-line']"
        :prepend-icon="$attrs['prepend-icon'] ? $attrs['prepend-icon'] : ''"
        :prepend-inner-icon="$attrs['prepend-inner-icon'] ? $attrs['prepend-inner-icon'] : ''"
        :append-icon="$attrs['append-icon'] ? $attrs['append-icon'] : 'arrow_drop_down'"
        :append-outer-icon="$attrs['append-outer-icon'] ? $attrs['append-outer-icon'] : ''"
    >
        <template v-for="(_, slot) of $slots" :slot=[slot]>
            <slot :name="slot"/>
        </template>
        <template v-for="(_, slot) of $scopedSlots" :slot=[slot] slot-scope="data">
            <slot :name="slot" v-bind="data" />
        </template>
    </v-text-field>
</template>

<script>

export default {
    props: ['focus', 'value'],
    computed: {
        selected: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        defaultPropsMenu(){
            return { auto: false }
        },
        menuPropsCombined(){ // use propsMenu in order to avoid conflicts with v-bind="$attrs"
            let propsMenu = this.$attrs.propsMenu ? this.$attrs.propsMenu : null;
            return this.$attrs.propsMenu ? { ...this.defaultPropsMenu, ...propsMenu } : { ...this.defaultPropsMenu };
        }
    }
};
</script>